import { render } from "./VBookingTotal.vue?vue&type=template&id=86693a00"
import script from "./VBookingTotal.vue?vue&type=script&setup=true&lang=js"
export * from "./VBookingTotal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/booking/VBookingTotal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86693a00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86693a00', __exports__)) {
    api.reload('86693a00', __exports__)
  }
  
  module.hot.accept("./VBookingTotal.vue?vue&type=template&id=86693a00", () => {
    api.rerender('86693a00', render)
  })

}


export default __exports__